import { gql } from 'urql';

const FetchPayOverTimeIntroDetails = gql`
  query PayOverTimeIntroDetails($input: PayOverTimeIntroInput!) {
    payOverTimeIntroDetails(input: $input) {
      __typename
      ... on PayOverTimeIntroDetailsSuccess {
        details
      }
      ... on PayOverTimeIntroSummarySuccess {
        summary
      }
      ... on PayOverTimeIntroError {
        code
        message
        title
      }
    }
  }
`;

export default FetchPayOverTimeIntroDetails;
